import { cpf } from "cpf-cnpj-validator";
import { formatCNPJ } from "./cnpjManager";

export default function cnpjCpfFormatter(value, type) {
  if (type === "F") {
    return cpf.format(value);
  } else if (type === "J") {
    return formatCNPJ(value);
  } else {
    return value;
  }
}
